import React from 'react';
import styles from './index.module.less';
import cn from 'classnames';
import { transImageSrc } from 'base/utils/trans-path';
import Link from '@base/lib/ThemeLink';
import { IBannerImageProps } from '@base/features/BannerImage/interface';
import { LazyLoad } from '@base/lib/LazyLoad';

export const BackgroundBanner = React.forwardRef<HTMLDivElement, IBannerImageProps>((props, ref) => {
    const {
        banner,
        width,
        height,
        onClick,
        onPopupClick
    } = props;

    if (!banner) {
        return <></>
    }

    const imgs = banner.largePicUrl ? (
        <LazyLoad>
            <div
                className="img img-normal"
                style={{ backgroundImage: `url(${transImageSrc(banner.picUrl, width, 2)})`, }}
            />
            <div
                className="img img-large"
                style={{ backgroundImage: `url(${transImageSrc(banner.largePicUrl, width * 2, 2)})`, }}
            />
        </LazyLoad>

    ) : (
        <LazyLoad>
            <div
                className="img"
                style={{ backgroundImage: `url(${transImageSrc(banner.picUrl, width, 2)})`, }}
            />
        </LazyLoad>
    );

    const trackerChildProps = {
        className: cn(
            styles['media-wrap'],
            styles['media-wrap-large'],
            'media-wrap'
        ),
        style: {
            backgroundColor: banner.bgColor || '#f1f0ed',
            height: `${height}px`,
            paddingBottom: `${(height / (width / 100)).toFixed(4)}%`
        },
        onClick
    }

    const trackerChild = banner.popUps
        ? (
            <div className={'pointer'}>
                <div
                    {...trackerChildProps}
                    aria-label={banner.altText || 'banner'}
                    role={'button'}
                    tabIndex={0}
                    onClick={() => {
                        onClick?.();
                        onPopupClick?.(banner)
                    }}
                >
                    {imgs}
                </div>
            </div>
        )
        : (
            <>
                {banner.linkUrl ? (
                    <Link href={banner.linkUrl}>
                        <a aria-label={banner.altText || 'banner'} {...trackerChildProps}>
                            {imgs}
                        </a>
                    </Link>
                ) : (
                    <div {...trackerChildProps}>
                        {imgs}
                    </div>
                )}
            </>
        );

    return ref ? (
        <div
            ref={ref}
            data-t-tar={props['data-t-tar']}
            data-t-pos={props['data-t-pos']}
        >
            {trackerChild}
        </div>
    ) : trackerChild
});
